module.exports = __webpack_public_path__ + "static/img/permata.4c2a7d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/permata.png
// module id = MPQ1
// module chunks = 1